// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21_yk","clinicsSelect":"styles_clinicsSelect__VOnA3"};